
import axios from "../axios-client";
import { env } from '../env';
import { parseErrors } from "./helpers";

const apiUrl: string = env.REACT_APP_DEVSECOPS_BACKEND_URL;

export const createReleaseNote = async (payload: any) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.post<any>(`${apiUrl}/devsecops/add-release-notes`, payload);
        return data.data;
    } catch (err: any) {
        if (err.response.data) {
            // throw parseErrors(err.response?.data.errors);
            throw err.response.data;
        }
    }
};

export const updateReleaseNote = async (payload: any) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.put<any>(`${apiUrl}/devsecops/update-release-notes`, payload);
        return data.data;
    } catch (err: any) {
        if (err.response.data) {
            // throw parseErrors(err.response?.data.errors);
            throw err.response.data;
        }
    }
};

export const deleteReleaseNote = async (payload: any) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.delete<any>(`${apiUrl}/devsecops/delete-release-notes`, {
            data: payload
        });
        return data.data;
    } catch (err: any) {
        if (err.response.data) {
            // throw parseErrors(err.response?.data.errors);
            throw err.response.data;
        }
    }
};

export const updateReleaseNoteStatus = async (payload: any) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.put<any>(`${apiUrl}/devsecops/update-release-notes-status`, payload);
        return data.data;
    } catch (err: any) {
        if (err.response.data) {
            // throw parseErrors(err.response?.data.errors);
            throw err.response.data;
        }
    }
};

export const updateReleaseNotePublishedStatus = async (payload: any) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.put<any>(`${apiUrl}/devsecops/update-release-notes-publish-status`, payload);
        return data.data;
    } catch (err: any) {
        if (err.response.data) {
            // throw parseErrors(err.response?.data.errors);
            throw err.response.data;
        }
    }
};

export async function fetchReleaseNotes(
    page: number,
    limit: number,
    searchText?: string,
    status?: string,
    type?: string,
) {
    try {
        let query = '';
        if (searchText && searchText !== "") {
            query += `&search_query=${searchText}`;
        }
        if (status) {
            if (status === "active") {
                query += '&is_active=true';
            }
            if (status === "in-active") {
                query += '&is_active=false';
            }
        }
        if (type && type !== "") {
            query += `&type=${type}`;
        }
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.get<ReleaseNotesResponse>(`${apiUrl}/devsecops/get-release-notes?page=${page}&limit=${limit}${query}`, { headers: { "timestamp": `${timeStamp}` } });
        return data.data.data;
    } catch (err: any) {
        if (err.response?.data) {
            throw parseErrors(err.response?.data.errors);
        }
        throw err;
    }
}

export const getSignedURL = async ({ version, file_name }: { version: string, file_name: string }) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.post<SignedURLResponse>(`${apiUrl}/devsecops/pre-signed-url-release-note`, { version, file_name }, { headers: { "timestamp": `${timeStamp}` } });
        return data.data;
    } catch (err: any) {
        if (err.response?.data) {
            throw parseErrors(err.response?.data.errors);
        }
        throw err;
    }
};

export const getDownloadURL = async ({ file_path }: { file_path: string }) => {
    try {
        const timeStamp = new Date().getTime();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const { data } = await axios.get<any>(`${apiUrl}/devsecops/signed-url-for-download-release-file?file_path=${file_path}`, { headers: { "timestamp": `${timeStamp}` } });
        return data.data;
    } catch (err: any) {
        console.log(err);
        if (err.response.data) {
            // throw parseErrors(err.response?.data.errors);
            throw err.response.data;
        }
        // if (err.response?.data) {
        //     throw parseErrors(err.response?.data.errors);
        // }
        // throw err;
    }
};


interface ReleaseNotesResponse {
    data: {
        data: {
            list: [any];
            count: number;
            page: string;
        };
    };
}

interface SignedURLResponse {
    data: {
        checksum: string;
        url: string;
        key: string;
    };
}